import { toError } from '@canvas/error';

export const readClipboardSafely = async (): Promise<ClipboardItems | Error> => {
  try {
    return await navigator.clipboard.read();
  } catch (maybeError) {
    return toError(maybeError);
  }
};
